<template>
  <section class="tables landing-page">
    <vue-snotify></vue-snotify>

    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title> Email Template </template>
      <div class="d-block">
        <h3 v-html="contentResData.Salutation"></h3>
        <br />
        <p v-html="contentResData.TextBox1"></p>
        <hr />

        <ul class="poll text-left">
          <li v-for="(landing, index) in landingPages" :key="index">
            <a :href="links.headingLink" target="_blank"><span style="font-weight: bold; text-decoration: underline"
                v-html="landing.Subject"></span>:</a>
            <span v-html="landing.Salutation"></span>
          </li>
        </ul>
        <hr />

        <p class="main-txt" v-html="contentResData.TextBox2"></p>
        <div v-show="pollShow">
          <ul style="list-style-type: none" class="poll text-left new-poll">
            <li :style="{ marginLeft: '45%' }" v-for="(item, index) in pollList" :key="index">
              <a href="javascript:void(0)"><img src="https://dctrainings.com/gts/images/newsletter/ebullet.png"
                  alt="" />
              </a><strong>{{ item.Topic }}</strong>
            </li>
          </ul>
        </div>
        <div v-html="contentResData.TextBox3" />
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button>
    </b-modal>

    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Landing page</h4>
          </div>
          <div class="card-body">
            <form action="" @submit.prevent="contentLoad" method="post">
              <div class="row">
                <div class="col-md-4 col-sm-6">
                  <div role="group" class="form-group">
                    <label for="ContentType" class="d-block">Content Type</label>
                    <div>
                      <select class="custom-select" id="ContentType" @change="getLandingPage"
                        v-model="contentData.ContentType" required name="ContentType">
                        <option value="Landing Page">Landing Page</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div role="group" class="form-group">
                    <label for="GroupID" class="d-block">Group</label>
                    <div>
                      <select class="custom-select" @change="getLandingPage" id="GroupID" v-model="contentData.GroupID"
                        required name="GroupID">
                        <option value="">Select Group</option>
                        <option value="1">Group 1</option>
                        <option value="2">Group 2</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div role="group" class="form-group">
                    <label for="TopicID" class="d-block">Select Topic</label>
                    <div>
                      <select class="custom-select" @change="getLandingPage" name="TopicID"
                        v-model="contentData.TopicID" required id="TopicID">
                        <option value="0">Please select an option</option>
                        <option v-for="(item, index) in topics" :key="index" :value="item.TopicID">
                          {{ item.Topic }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6" v-show="partShow">
                  <div role="group" class="form-group">
                    <label for="part" class="d-block">Part</label>
                    <div>
                      <select id="part" @change="getLandingPage" name="PartID" v-model="contentData.PartID"
                        class="custom-select">
                        <option value="" selected>
                          Please select an option
                        </option>
                        <option v-for="n in 4" :value="n" :key="n">
                          part {{ n }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div role="group" class="form-group">
                    <label for="input11" class="d-block">Select Landing page</label>
                    <div>
                      <select name="Landingpage" v-model="contentData.Landingpage" class="custom-select" required>
                        <option value="">Select Landing page</option>
                        <option value="0">Create New</option>
                        <option v-for="(item, index) in landingDropdownData" :key="index" :value="item.ContentID">
                          {{ item.subject }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div class="form-group">
                    <input type="submit" class="btn btn-success mt-4" value="content" />
                  </div>
                </div>
              </div>
            </form>

            <div class="landing-body" v-show="showDataForm">
              <div class="landing-btn text-center p-3 border">
                <!-- <router-link class="nav-link btn btn-primary btn-sm" :to="{ name: `landing_page_view`, params:  {...contentData,...contentResData,...topics}  }" target="_blank" >List of Email</router-link> -->
                <b-button variant="success" @click="$bvModal.show('bv-modal-example')" class="btn btn-success">
                  <span>View Template</span>
                </b-button>
              </div>
              <div class="landing-form p-3 border mt-3">
                <form @submit.prevent="updateOrSaveLandingPage" method="post">
                  <div role="group" class="form-group">
                    <label for="name" class="d-block">Name</label>
                    <div>
                      <input id="name" name="name" type="text" placeholder="Name" class="form-control form-control-sm"
                        v-model="contentResData.Subject" />
                    </div>
                  </div>
                  <div role="group" class="form-group">
                    <label for="Heading" class="d-block">Heading</label>
                    <div>
                      <input id="Heading" name="heading" type="text" v-model="contentResData.Salutation"
                        placeholder="Heading" class="form-control form-control-sm" />
                    </div>
                  </div>
                  <div role="group" class="form-group">
                    <label for="TextBox1" class="d-block">Description 1</label>
                    <div>
                      <ckeditor id="TextBox1" v-model="contentResData.TextBox1" :config="editorConfig">
                      </ckeditor>
                    </div>
                  </div>
                  <div role="group" class="form-group">
                    <label for="TextBox2" class="d-block">Description 2</label>
                    <div>
                      <ckeditor id="TextBox2" v-model="contentResData.TextBox2" :config="editorConfig1">
                      </ckeditor>
                    </div>
                  </div>

                  <div role="group" class="form-group">
                    <label for="TextBox3" class="d-block">Description 3</label>
                    <div>
                      <ckeditor id="TextBox3" v-model="contentResData.TextBox3" :config="editorConfig2">
                      </ckeditor>
                    </div>
                  </div>
                  <div role="group" class="form-group">
                    <label for="Orderby" class="d-block">Landing Page Order</label>
                    <div>
                      <input id="Orderby" name="Orderby" type="number" placeholder="Landing Page Order"
                        v-model="contentResData.orderby" class="form-control form-control-sm" />
                    </div>
                  </div>
                  <div role="group" class="form-group">
                    <div class="checkbox d-flex justify-content-center align-items-center">
                      <label class="m-0"><input type="checkbox" :checked="contentResData.Active == true"
                          @click="cahngeCheck" name="Active" />
                        Active For Email Marketing</label>
                      <input type="submit" class="btn btn-success btn-sm ml-3" value="Submit" name="AddEditContent" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>

<script>
import Vue from "vue";
import API from "@/api";
import CKEditor from "ckeditor4-vue";

Vue.use(CKEditor);

export default {
  name: "landing_page",
  data() {
    return {
      contentData: {
        ContentType: "Landing Page",
        GroupID: "",
        TopicID: 0,
        Landingpage: "",
        PartID: "",
      },
      editorConfig: {
        versionCheck: false
      }, 
      editorConfig1: {
        versionCheck: false
      },
      editorConfig2: {
        versionCheck: false
      },
      partShow: false,
      showDataForm: false,
      contentResData: {
        TextBox1: " ",
        TextBox2: " ",
        TextBox3: " ",
        Subject: " ",
        orderby: "",
        Active: false,
      },
      Active: "",
      topics: {},
      landingDropdownData: {},
    };
  },
  methods: {
    cahngeCheck(event) {
      this.contentData.Active = event.target.checked;
    },
    updateOrSaveLandingPage() {
      API.updateOrSaveLandingPage(
        {
          ...this.contentData,
          ...this.contentResData,
          ...{ Active: this.contentData.Active },
        },
        this.updateOrSaveCB,
        this.errorCb
      );
    },
    updateOrSaveCB(response) {
      this.contentResData = response.data;
      this.$showNotification({ message: "Successfully Updated" }, "success");
    },
    getTopics() {
      API.getTopics(this.topicData, this.errorCb);
    },
    topicData(data) {
      this.topics = data.data;
    },
    contentLoad() {
      if (
        this.contentData.Landingpage == "0" &&
        this.contentData.Landingpage != ""
      ) {
        this.showDataForm = true;
      } else {
        API.getLandingPagecontent(
          this.contentData,
          this.pageData,
          this.errorCb
        );
      }
    },
    pageData(data) {
      this.$showNotification(
        { message: "Succesfully recieved data" },
        "success"
      );
      this.contentResData = data.data;
      this.contentData.Active = data.data.Active == 0 ? false : true;
      this.showDataForm = true;
    },
    getLandingPage() {
      if (this.contentData.GroupID == 2) {
        this.partShow = true;
      } else if (
        this.contentData.GroupID == 1 ||
        this.contentData.GroupID == ""
      ) {
        this.contentData.PartID = 0;
        this.partShow = false;
      }
      this.getLandingpagesDropdown();
    },
    getLandingpagesDropdown() {
      API.getLandingpagesDropdown(
        this.contentData,
        this.landingDataCB,
        this.errorCb
      );
    },
    landingDataCB(response) {
      this.landingDropdownData = response.data;
    },
    viewTemplate() {
      this.links.headingLink = `https://dctrainings.com/LandingPage.cfm?pageid=${this.contentResData.id}&title=${this.contentResData.Subject}`;
    },
    errorCb(err) {
      console.log(err);
      this.$showNotification({ message: "Failed system error" }, "error");
    },
  },
  mounted() {
    this.getTopics();
  },
};
</script>
<style>
@media (max-width: 767px) {
  .btn-success.mt-4 {
    margin-top: 0 !important;
  }
}
</style>

<style>
#bv-modal-example .modal-dialog {
  max-width: 1001px;
}
</style>